import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useParams } from 'react-router-dom'

import { DespatchAdviceData } from '../features/despatch-advice/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const DespatchAdvicePage: React.FC = () => {
  const { id } = useParams()

  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <DespatchAdviceData id={id as string} />
    </ErrorBoundary>
  )
}
